import OtherAddr from './OtherAddr'

export default OtherAddr
